import { SHOW_PROFILES_GATE } from './lock.actions';

const initialState = {
  shouldDisplayProfilesGate: false,
};

export default (state = initialState, action) => {
  switch (action && action.type) {
    case SHOW_PROFILES_GATE: {
      return {
        ...state,
        shouldDisplayProfilesGate: true,
      };
    }
    default: {
      return state;
    }
  }
};
